function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "c delete");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "nc-icon-wrapper",
  strokeWidth: 0.8,
  fill: "#000000",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.5,
  fill: "none",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 6,
  x2: 9,
  y2: 6,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "data-color": "color-2"
}));

var SvgCDelete = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    width: 16,
    height: 16,
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/c-delete.9664e469.svg";
export { ForwardRef as ReactComponent };